<div class="total-details mt-4">
	<table class="table table-hovered table-bordered">
		<tr>
			<th></th>
			<th>FARE BREAKUP</th>
			<th>SUPPLIER</th>
			<th>CLIENT</th>

		</tr>
		<tr>
			<td>
				<table class="w-100">
					<tr>
						<th class="text-left">Reference</th>
					</tr>
					<tr *ngFor="let invoice of sectorService.fareList let i = index">
						<td class="text-left">
							<a class="hyperLink" *ngIf="invoice.invoice_no != undefined" (click)="viewPrintScreen(invoice.invoice_no,i)">{{invoice.invoice_no}} 
								<ng-container *ngIf="invoice.type == 'reissue'">(R)</ng-container>
								<ng-container *ngIf="invoice.type == 'split'">(S)</ng-container>
							</a>
							<a class="hyperLink" *ngIf="invoice.invoice_no == undefined" (click)="viewPrintScreen(invoice,i)">{{invoice}} <ng-container *ngIf="invoice.type == 'reissue'">(R)</ng-container></a>
						</td>
					</tr>
				</table>

			</td>
			<td class="inner-supplier-table">
				<table class="w-100">
					<tr>
						<th class="text-right">Base</th>
						<th class="text-right">YQ</th>
						<th class="text-right">YR</th>
						<th class="text-right">K3</th>
						<th class="text-right">OC</th>
						<th class="text-right">OT</th>
						<th class="text-right">SSR</th>
					</tr>
					<tr *ngFor="let invoice_no of sectorService.fareList let i = index">
						<td class="text-right">{{sectorService?.totalFareModel[i]?.base | number : '1.2-2'}}</td>
						<td class="text-right">{{sectorService?.totalFareModel[i]?.yq | number : '1.2-2'}}</td>
						<td class="text-right">{{sectorService?.totalFareModel[i]?.yr | number : '1.2-2'}}</td>
						<td class="text-right">{{sectorService?.totalFareModel[i]?.k3 | number : '1.2-2'}}</td>
						<td class="text-right">{{sectorService?.totalFareModel[i]?.oc | number : '1.2-2'}}</td>
						<td class="text-right">{{sectorService?.totalFareModel[i]?.ot | number : '1.2-2'}}</td>
						<td class="text-right">{{sectorService?.totalFareModel[i]?.ssr | number : '1.2-2'}}</td>
					</tr>
				</table>

			</td>
			<td class="inner-supplier-table">
				<table class="w-100">
					<tr>
						<th class="text-right">TDS</th>
						<th class="text-right" *ngIf="isTenantIndian">GST</th>
						<th class="text-right" *ngIf="!isTenantIndian">{{vatAlternetname}}</th>
						<th class="text-right">Comm.</th>
						<th *ngIf="discount_add=='true'" class="text-right">Discount</th>
						<th class="text-right">SC.T</th>
						<th class="text-right">SC.N</th>
						<th class="text-right">Net Amount</th>
					</tr>
					<tr *ngFor="let invoice of sectorService.fareList let i = index">
						<td class="text-right">{{sectorService?.totalFareModel[i]?.tds_paid | number : '1.2-2'}}</td>
						<td class="text-right" *ngIf="isTenantIndian">{{sectorService?.totalFareModel[i]?.gst_paid | number : '1.2-2'}}</td>
						<td class="text-right" *ngIf="!isTenantIndian">{{sectorService?.totalFareModel[i]?.vat_paid | number : '1.2-2'}}</td>
						<td class="text-right">{{sectorService?.totalFareModel[i]?.commission_received | number : '1.2-2'}}</td>
						<td *ngIf="discount_add=='true'" class="text-right">{{sectorService?.totalFareModel[i]?.discount_received | number : '1.2-2'}}</td>
						<td class="text-right">{{sectorService?.totalFareModel[i]?.supplier_service_charges | number : '1.2-2'}}</td> 
						<td class="text-right">{{sectorService?.totalFareModel[i]?.supplier_normal_service_charges | number : '1.2-2'}}</td> 
						
						<td class="text-right" *ngIf="(invoice.invoice_no && (
							invoice.invoice_no.toString().includes('INV') || invoice.invoice_no.toString().includes('IW') || invoice.invoice_no.toString().includes('BSI') || invoice.invoice_no.toString().includes('IST') || invoice.invoice_no.toString().includes('DST') || invoice.invoice_no.toString().includes('DSW') || invoice.invoice_no.toString().includes('ISW') ||
							 invoice.invoice_no.toString() == 'New Invoice')) || invoice.toString() == 'New Invoice' ">
							 {{sectorService?.totalFareModel[i]?.net_paid | number : '1.2-2'}}
							</td>
						<td class="text-right" *ngIf="invoice.invoice_no && (
							invoice.invoice_no.toString().includes('CRN') || invoice.invoice_no.toString().includes('IZ'))">
							{{sectorService?.totalFareModel[i]?.net_received | number : '1.2-2'}}
						</td>
					</tr>
				</table>

			</td>
			<td>
				<table class="w-100">
					<tr>
						<th class="text-right">TDS</th>
						<th class="text-right" *ngIf="isTenantIndian">GST</th>
						<th class="text-right" *ngIf="!isTenantIndian">{{vatAlternetname}}</th>
						<th class="text-right">Comm.</th>
						<th *ngIf="discount_add=='true'" class="text-right">Discount</th>
						<th class="text-right">SC.T</th>
						<th class="text-right">SC.N</th>
						<th class="text-right">R/O</th>
						<th class="text-right">Net Amount</th>
					</tr>
					<tr *ngFor="let invoice of sectorService.fareList let i = index">
						<td class="text-right">{{sectorService?.totalFareModel[i]?.tds_recieved | number : '1.2-2'}}</td>
						<td class="text-right" *ngIf="isTenantIndian">{{sectorService?.totalFareModel[i]?.gst_recieved | number : '1.2-2'}}</td>
						<td class="text-right" *ngIf="!isTenantIndian">{{sectorService?.totalFareModel[i]?.vat_received | number : '1.2-2'}}</td>
						<td class="text-right">{{sectorService?.totalFareModel[i]?.commission_paid | number : '1.2-2'}}</td>
						<td *ngIf="discount_add=='true'" class="text-right">{{sectorService?.totalFareModel[i]?.discount_paid | number : '1.2-2'}}</td>
						<td class="text-right">{{sectorService?.totalFareModel[i]?.client_service_charges | number : '1.2-2'}}</td> <!--  TODO : Calculate in fare calculation -->
						<td class="text-right">{{sectorService?.totalFareModel[i]?.client_normal_service_charges | number : '1.2-2'}}</td> <!--  TODO : Calculate in fare calculation -->
						<td class="text-right">{{sectorService?.totalFareModel[i]?.round_off | number : '1.2-2'}}</td>
						<td class="text-right" *ngIf="(invoice.invoice_no && (
							invoice.invoice_no.toString().includes('INV') || invoice.invoice_no.toString().includes('IW') || invoice.invoice_no.toString().includes('BSI') || invoice.invoice_no.toString().includes('IST') || invoice.invoice_no.toString().includes('DST') || invoice.invoice_no.toString().includes('DSW') || invoice.invoice_no.toString().includes('ISW') ||
							invoice.invoice_no.toString() == 'New Invoice')) || invoice.toString() == 'New Invoice'">
							{{sectorService?.totalFareModel[i]?.net_received | number : '1.0-0'}}</td>
						<td class="text-right" *ngIf="invoice.invoice_no && (invoice.invoice_no.toString().includes('CRN') || invoice.invoice_no.toString().includes('IZ'))">{{sectorService?.totalFareModel[i]?.net_paid | number : '1.0-0'}}</td>
					</tr>
				</table>

			</td>

		</tr>
	</table>
</div>